/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class InlineEditDateDirective {
    public restrict = 'E';
    public scope;
    public template;
    public currentValue;
    public minDate = new Date('1930/01/01');

constructor(private $timeout: any) {
        this.restrict = 'E';
        this.scope = {
            value: '=',
            saveFunc: '&?',
            label: '@?',
            canEdit: '=?'
        };

        this.template = `
        <md-input-container class="d-flex w-100"> 
            <label class="r-auto p-l-0">{{label}}</label>
            <md-datepicker class="w-100 d-flex" md-min-date="minDate" ng-click="edit()" ng-model="value" md-placeholder="Enter Date" md-open-on-focus ng-change="doneEdit()", ng-disabled="canEdit == false"></md-datepicker>
        </md-input-container>
        
        `; 
    }


    public link($scope: any, $element: any, attrs: any): any {
        $scope.$watch('value', function(): any {
            
            if ($scope.value === '---' || $scope.value === 'Invalid Date') {
                $scope.value = '';
            } else {
            }
        });

        $scope.edit = function (): any {
            this.currentValue = moment($scope.value).format('YYYY-MM-DD');
        };

        $scope.doneEdit = function (): any {
            var newValue: any  = moment($scope.value).format('YYYY-MM-DD');
            var saveObj: any = {
                old: this.currentValue,
                new: newValue,
                model: attrs.value
            };
            if ($scope.saveFunc !== undefined) {
                $scope.saveFunc({args: saveObj});
            }
        };
    }

    public static DirectiveFn($timeout: any): InlineEditDateDirective {
        return new InlineEditDateDirective($timeout);
    }
}

InlineEditDateDirective.DirectiveFn.$inject = ['$timeout'];

angular.module('beneple.global').directive('inlineEditDate', InlineEditDateDirective.DirectiveFn);



// WEBPACK FOOTER //
// ./frontend/scripts/global/directives/inline_edit_date.directive.ts